export default __webpack_public_path__ + "static/media/banner01.8ba5c0ca.png";